import React from 'react'
import { Link } from "react-router-dom"
import { Result } from 'antd'
import language from "../resources/languages/fa_IR"

const { Pages: { NotAuth: NotAuthLanguage }, Share } = language

export default function NotAuth() {

    return <Result
        status="403"
        title="403"
        subTitle={NotAuthLanguage.description}
        extra={<Link to="/">{Share.backDashboard}</Link>}
    />
}
